import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IEditDialogData} from "../../../components/category-tree/tree-service/tree-data.model";
import {TranslocoService} from "@ngneat/transloco";
import {LocalStoreService} from "../../../services";
import {convertNumberToBoolean} from "../../../common";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-youtube-license-dialog',
    templateUrl: './youtube-license-dialog.component.html',
    styleUrls: ['./youtube-license-dialog.component.scss']
})
export class YoutubeLicenseDialogComponent extends Compbaser implements OnInit {

    constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,
                private localStoreService: LocalStoreService,
                private toastr: ToastrService) {
        super();
    }

    ngOnInit() {
    }

    agree() {
        this.localStoreService.setStorageValConfig('isYouTubeLicense', "1");
        this.closeDiag();
        this.toastr.info('YouTube usage allowed, Go ahead and add a new YouTube component');
    }

    closeDiag() {
        this.dialogRef.close();
    }

}
